"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiTheme = void 0;
const react_1 = require("react");
function UiTheme({ type }) {
    react_1.useEffect(() => {
        document.documentElement.setAttribute(type, '1');
        return () => document.documentElement.removeAttribute(type);
    }, [type]);
    return null;
}
exports.UiTheme = UiTheme;
